import { render, staticRenderFns } from "./index_4.vue?vue&type=template&id=5c5d052c&scoped=true"
import script from "./index_4.vue?vue&type=script&lang=js"
export * from "./index_4.vue?vue&type=script&lang=js"
import style0 from "./index_4.vue?vue&type=style&index=0&id=5c5d052c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d052c",
  null
  
)

export default component.exports